// Ready-made institutional text presets the tenant admin can start from
// (still fully editable afterwards) for the "Institucional" landing layout.
export const INSTITUTIONAL_TEXT_TEMPLATES = [
  {
    key: 'private',
    label: 'Setor Privado',
    html: '<p>A [Nome da Empresa] promove uma cultura de integridade e transparência. Este canal permite denunciar, de forma confidencial ou anónima, factos ocorridos no contexto profissional que possam constituir infrações ao abrigo da Lei 93/2021.</p><p>Toda a informação é tratada exclusivamente pelo gestor de compliance, com garantia de confidencialidade e proteção contra represálias. Não é necessário identificar-se para submeter uma denúncia.</p>',
  },
  {
    key: 'public',
    label: 'Setor Público',
    html: '<p>Este canal de denúncias foi criado no âmbito do cumprimento da Lei 93/2021 e destina-se a colaboradores, prestadores de serviços e cidadãos que pretendam reportar situações de gestão danosa, corrupção ou outras infrações relacionadas com o exercício de funções públicas.</p><p>As denúncias são analisadas por um responsável de gestão de denúncias designado, respeitando os prazos legais de acusação de receção (7 dias) e de resposta (90 dias).</p>',
  },
  {
    key: 'sme',
    label: 'PME',
    html: '<p>Valorizamos um ambiente de trabalho ético e seguro. Se identificou uma situação irregular, use este canal para nos alertar — de forma anónima, se preferir.</p><p>A sua denúncia será analisada com confidencialidade e sem qualquer forma de retaliação.</p>',
  },
];
